import {Component} from '@angular/core';
import {InfoModalComponent} from "app/views/modal/info_modal.component";
import {getSiteStatusStyle} from "app/lib/lib";

@Component({
	templateUrl: './domain_zones_details.component.html'
})
export class DomainZonesDetailsComponent extends InfoModalComponent {
	public getSiteStatusStyle = getSiteStatusStyle;
	
	details;

	ok() {
		this.close();
	}
}
